module.exports = __webpack_public_path__ + "static/media/card_2.bae0a360.png";